import axios from "axios";
import { urlBaseHall } from './../../config/index';
import adminUserService from '../adminUser';

export default async function getSchedulesHallApi(
  eventId = '',
) {
  try {
    const _token = await adminUserService.getHallTokenByEventId(eventId);

    const _config = {
      url: `${urlBaseHall}/hall/api/schedule?eventId=${eventId}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "bearer " + _token,
      },
    };

    const _ret = await axios(_config);

    const _return = [];
    _ret.data.forEach(item => {
      if (item.active === null || item.active === true) {
        let _sched = {
          id: item.id,
          value: item.id.toString(),
          text: item.title,
        }
        _return.push(_sched);
      }
    });
    _return.sort((a, b) => (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0));
    return _return;

  } catch (error) {
    console.log('Error getSchedulesHallApi', error);
    throw error;
  }
}
